import * as React from 'react';
import { Col, Media, Row } from 'react-bootstrap';
import InlineTooltip from '../../../../../../components/common/ToolTip';
import { PACKAGE_PRODUCT_ID } from "../../../../../../debug/orders/createOrder/v1/state/debugFiller";
import { groupBy } from '../state/productHelper';

type PackageProductsProps = {
    products: any;
    onClickProduct: (id: number) => void;
};

export function PackageProducts({ products, onClickProduct }: PackageProductsProps) {
    let groupedProducts = groupBy('productType', products);

    return (
        <>
            {Object.keys(groupedProducts)
                .sort()
                .map((groupProperty: string, index: number) => {
                    return (
                        <Row key={index}>
                            <div className="rowlabel">
                                {groupedProducts[groupProperty][0] &&
                                    groupedProducts[groupProperty][0].productTypeName}
                            </div>
                            {groupedProducts[groupProperty].map((x: any, index: number) => {
                                return (
                                    <Col key={x.Id + '-' + index} xs={12} sm={6} md={4} lg={3}>
                                        <Media
                                            id={`${PACKAGE_PRODUCT_ID}_${index}`}
                                            data-testid={`package-product-${x.id}`}
                                            className={
                                                'product-box ' +
                                                (x.available ? 'photo ' : 'disabled ') +
                                                (x.selected ? 'selected ' : ' ') +
                                                (x.required ? 'required ' : ' ')
                                            }
                                            onMouseUp={() => onClickProduct(x.id)}
                                        >
                                            <Media.Left align="middle">
                                                <i className="material-icons">photo_camera</i>
                                            </Media.Left>
                                            <Media.Body>
                                                <Col sm={8}>
                                                    <h5>{x.name} </h5>
                                                </Col>
                                                {x.priceBrokerFirm !== null ? (
                                                    <Col sm={4} className="price-broker-firm">
                                                        <p>
                                                            {x.priceBrokerFirm.value}
                                                            {x.currencySign}
                                                        </p>
                                                    </Col>
                                                ) : (
                                                    ''
                                                )}
                                            </Media.Body>
                                            <Media.Right align="middle">
                                                <InlineTooltip id={x.id} tooltip={x.extraText} />
                                            </Media.Right>
                                        </Media>
                                    </Col>
                                );
                            })}
                        </Row>
                    );
                })}
        </>
    );
}
